import React from 'react'

import { MultiSelectTextInput, MultiSelectTextInputOption } from '@driftt/dds'

/**
 *
 *
 * @param {WordsOrPhrasesProps} WordsOrPhrasesProps
 * @returns {JSX.Element} JSX.Element
 */
export const WordsOrPhrases = ({ selectedValue, isDisabled, onChange }) => {
  const multiSelectInputValues: MultiSelectTextInputOption[] =
    selectedValue.map((each) => {
      return { value: each, label: each }
    })

  return (
    <MultiSelectTextInput
      initialValue={multiSelectInputValues}
      isDisabled={isDisabled}
      onChange={(options) => {
        const selectedValues = options.map((option) => option.value)
        onChange(selectedValues)
      }}
    />
  )
}
